export const gitCommit = 'abfc20ee'
